import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-timeline-add-site',
    templateUrl: './timeline-add-site.component.html',
    styleUrls: ['./timeline-add-site.component.scss'],
    standalone: false
})
export class TimelineAddSiteComponent implements OnInit {

  @Input()
  isLoaded = false;
  constructor() { }

  ngOnInit(): void {
  }

}
